import { Constants } from '../Constants';
import { QuestionItem, QuestionType } from '../Models/Questions/QuestionDto';
import { StoreDto } from '../Models/TravelExpenses/StoreDto';
import { LocalityDto } from '../Models/TravelExpenses/TravelExpenseDto';
import { QuoteState } from '../Web/Pages/Quote/QuoteState';

export class StoreHelper {
    public static toDesciption(store: StoreDto) {
        const [line1] = store.address_lines || [];
        return `${line1}, ${store.zipcode} ${store.city}`;
    }

    public static toBookAppointmentUrl(store?: StoreDto) {
        const websiteUrl = store?.website;
        if (websiteUrl) {
            const storeSlug = websiteUrl.slice(websiteUrl.lastIndexOf('/') + 1);
            return Constants.STMAC_BOOK_APPOINTMENT_URL(storeSlug);
        }
        return Constants.STMAC_BOOK_APPOINTMENT_URL();
    }

    public static getAddressLocality = (questions: QuestionItem[] = []): LocalityDto | undefined => {
        const zipCodeQuestion = questions.find((x) => x.type === QuestionType.ZipCode);
        return zipCodeQuestion?.zipCodeValue;
    };

    public static getProjectStoreLead = ({ projetStoreLead, stepHabitation }: Partial<QuoteState>): StoreDto | undefined => {
        return projetStoreLead ?? StoreHelper.getAddressLocality(stepHabitation?.questions)?.travel_expenses?.store_lead
    };

    public static getProjectStoreDelivery = ({ projetStoreDelivery, stepHabitation }: Partial<QuoteState>): StoreDto | undefined => {
        return projetStoreDelivery ?? StoreHelper.getAddressLocality(stepHabitation?.questions)?.travel_expenses?.store_delivery
    };

    public static getProjectLocation = ({ stepHabitation, stepSynthese }: Partial<QuoteState>): LocalityDto | undefined => {
        return StoreHelper.getAddressLocality([...stepHabitation?.questions || [], ...stepSynthese?.questions || []])
    };

    public static getProjectStores = (state: Partial<QuoteState>) => {
        return {
            projetStoreLead: StoreHelper.getProjectStoreLead(state),
            projetStoreDelivery: StoreHelper.getProjectStoreDelivery(state),
        }
    };
}
